exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home .container-fluid .row h4 {\n  width: 100%;\n  text-align: center;\n}\n.loding_slider {\n  height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}", ""]);

// exports
